import authenticationReducer from './auth';

const AppReducer = ({ authentication }, action) => ({
  authentication: authenticationReducer(authentication, action)
});

export default AppReducer;